import React from 'react';
import PropTypes from 'prop-types';

import { ButtonWithIcon } from '@els/els-react--button';

function RsSlidableNavigationNext({ disabled, onClick }) {
  return (
    <ButtonWithIcon sprite="ChevronRight" disabled={disabled} iconOnly type="link" onClick={onClick}>
      Slide next
    </ButtonWithIcon>
  );
}

RsSlidableNavigationNext.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default RsSlidableNavigationNext;
